/** The dim-semantics concept index (services/vocabulary.service.ts), loaded once. */

import { useEffect, useState } from 'react';
import { loadConcepts, type ConceptIndex } from '@services/vocabulary.service';

export function useConcepts(): ConceptIndex | undefined {
  const [index, setIndex] = useState<ConceptIndex>();
  useEffect(() => {
    let cancelled = false;
    loadConcepts().then((result) => !cancelled && setIndex(result));
    return () => {
      cancelled = true;
    };
  }, []);
  return index;
}
